import React from "react"
import { Route } from "react-router-dom"
import { splitId } from "@components/content-feed/admin/manager"
import DetailModal from "@components/content-feed/modal"

const DetailRoute = ({ items }) => (
  <Route
    path="/detail/:detail_id/:asset_id/:item_id?/:anchor?"
    component={({
      match: {
        params: { detail_id, asset_id, item_id, anchor },
      },
    }) => {
      const item =
        items.find(i => i.id == "item_" + item_id) ||
        items.find(
          i => i.teaser_id == "teaser_" + item_id || i.detail_row == detail_id
        )
      item && (item_id = splitId(item.id))

      return (
        <DetailModal
          detailId={detail_id}
          detailAsset={asset_id}
          itemId={item_id}
          item={item}
          anchor={anchor}
          onHide={() => void (location.hash = "#/")}
        />
      )
    }}
  />
)

export default DetailRoute
